import { getDiffusionsHandler } from './overrides/getDiffusionsHandler'
import { getPartenairesHandler } from './overrides/getPartenairesHandler'
import { publishDiffusionForProductHandler } from './overrides/publishDiffusionForProductHandler'
import { relaunchDiffusionForProductHandler } from './overrides/relaunchDiffusionForProductHandler'
import { relaunchDiffusionHandler } from './overrides/relaunchDiffusionHandler'
import { unpublishDiffusionForProductHandler } from './overrides/unpublishDiffusionForProductHandler'

export const handlers = [
  getDiffusionsHandler(),
  getPartenairesHandler(),
  relaunchDiffusionHandler(),
  relaunchDiffusionForProductHandler(),
  publishDiffusionForProductHandler(),
  unpublishDiffusionForProductHandler(),
]
